import { Box, Container, Paper, Typography, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Switch, FormGroup } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setUnitSystem, setShowUserLocation, updateSettings } from './chartSettings/ChartSettingsSlice';
import { loadRWGPSAuth } from './auth/AuthSlice';
import { useEffect } from 'react';
import RouteSources from './routeSelection/RouteSources';
import analyticsService from '../services/analytics';

function AppSettings() {
    const dispatch = useDispatch();
    const unitSystem = useSelector((state) => state.chartSettings.chartSettings.unitSystem);
    const showUserLocation = useSelector((state) => state.chartSettings.chartSettings.showUserLocation);
    const buildSha = process.env.REACT_APP_BUILD_SHA || 'development';

    useEffect(() => {
        // Load RWGPS auth data from IndexedDB
        dispatch(loadRWGPSAuth());
    }, [dispatch]);

    const handleUnitChange = (event) => {
        const newUnitSystem = event.target.value;
        dispatch(setUnitSystem(newUnitSystem));
        dispatch(updateSettings({
            unitSystem: newUnitSystem,
            showUserLocation
        }));

        // Track settings change
        analyticsService.trackSettingsChange('unit_system', newUnitSystem);
    };

    const handleShowLocationChange = (event) => {
        const newValue = event.target.checked;
        dispatch(setShowUserLocation(newValue));
        dispatch(updateSettings({
            unitSystem,
            showUserLocation: newValue
        }));

        // Track settings change
        analyticsService.trackSettingsChange('show_user_location', newValue);
    };



    return (
        <Container maxWidth="lg">
            <Box sx={{ py: 4 }}>
                <Typography variant="h4" gutterBottom>
                    App Settings
                </Typography>

                {/* App Settings */}
                <Paper elevation={2} sx={{ p: 3, mb: 4 }}>
                    <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
                        App Settings
                    </Typography>
                    <FormControl component="fieldset" sx={{ mb: 3 }}>
                        <FormLabel component="legend">Unit System</FormLabel>
                        <RadioGroup
                            value={unitSystem}
                            onChange={handleUnitChange}
                            name="unit-system"
                        >
                            <FormControlLabel
                                value="imperial"
                                control={<Radio />}
                                label="Imperial (miles, feet)"
                            />
                            <FormControlLabel
                                value="metric"
                                control={<Radio />}
                                label="Metric (kilometers, meters)"
                            />
                        </RadioGroup>
                    </FormControl>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={showUserLocation}
                                    onChange={handleShowLocationChange}
                                />
                            }
                            label="Show user location"
                        />
                    </FormGroup>
                </Paper>
                {/* Route Source Connections */}
                <RouteSources />

                <Box sx={{ mt: 4, textAlign: 'center' }}>
                    <Typography variant="caption" color="text.disabled">
                        Build: {buildSha}
                    </Typography>
                </Box>
            </Box>
        </Container>
    );
}

export default AppSettings; 